export default class Tooltip {
    constructor() {
        this.createTooltip.bind(this);
        window.addEventListener('DOMContentLoaded', this._init.bind(this));
        window.addEventListener('DOMContentLoaded', this._buttons_init.bind(this));
        window.addEventListener('DOMContentLoaded', this._timeout_init.bind(this));        
    }

    createTooltip(element, options) {
        // add uid to element
        element.setAttribute('tooltip-uid', options.uid);
    
        // create tooltip element
        var tooltip = document.createElement('div');
        tooltip.className = 'tooltip-item';
        tooltip.setAttribute('tooltip-uid', options.uid);
        tooltip.setAttribute('style', 'display:none;');
    
        // create tooltip content based on mode
        switch (options.mode) {
            case 'html':
                tooltip.innerHTML = options.content;
                break;
            case 'text':
            default:
                tooltip.innerText = options.content;
                break;
        }
    
        // add tooltip arrow element
        tooltip.insertAdjacentHTML('beforeend', '<div class="tooltip-item-arrow"></div>');
    
        // add tooltip position class
        if (options.position) {
            tooltip.className += ' tooltip-item--' + options.position;
        }
    
        // add tooltip to the dom
        document.body.appendChild(tooltip);
    
        // handle external triggers
        // handle external triggers
        if (options.hasOwnProperty('trigger')) {
            var trigger = document.querySelector(options.trigger);
            if (trigger && trigger.classList.contains('tooltip-trigger-checked')) {
                var checkbox = trigger.querySelector('input[type="checkbox"]');
                checkbox.addEventListener('change', function (e) {
                    if (checkbox.checked) {
                        openTooltip(e);
                    } else {
                        closeTooltip(e);
                    }
                });
                trigger.addEventListener('mouseleave', function (e) {
                    closeTooltip(e)
                });
            }
        }
    
        // show tooltip on hover
        element.addEventListener('mouseenter', function (e) {
            openTooltip(e);
        });
    
        // hide tooltip on no hover
        element.addEventListener('mouseleave', function (e) {
            closeTooltip(e);
        });
    
        var openTooltip = function openTooltip(e) {
            tooltip.setAttribute('style', 'display:block;position:absolute;top:-9999px;left:-9999px;');
            var ttdim = tooltip.getBoundingClientRect();
            var elpos = element.getBoundingClientRect();
            var woffs = {
                top: window.pageYOffset,
                left: window.pageXOffset
            };
            var ttpos = {
                top: 'auto',
                right: 'auto',
                bottom: 'auto',
                left: 'auto'
            };
            switch (options.position) {
                case 'right':
                    ttpos.top = elpos.top + woffs.top - (elpos.height + ttdim.height) + 'px';
                    ttpos.left = elpos.left + woffs.left - ttdim.width + 'px';
                    break;
                default:
                    ttpos.top = elpos.top + woffs.top - (elpos.height + ttdim.height) + 'px';
                    ttpos.left = elpos.left + woffs.left + 'px';
                    break;
            }
            var styles = 'position:absolute;top:' + ttpos.top + ';right:' + ttpos.right + ';bottom:' + ttpos.bottom + ';left:' + ttpos.left + ';z-index:9999;';
            if (options.style) {
                styles += options.style;
            }
            tooltip.setAttribute('style', styles);
        };
    
        var closeTooltip = function closeTooltip(e) {
            tooltip.setAttribute('style', 'display:none;');
        };
    }

    _init() {
        // get all .tooltip elements
        var tooltips = document.querySelectorAll('.tooltip');
        // loop over .tooltip elements and bind mouse events
        for (var i = 0; i < tooltips.length; i++) {
            var tooltip = tooltips[i];
            // default tooltip options
            var options = {
                uid: Math.floor((1 + Math.random()) * 0x10000).toString(16).substr(1),
                mode: 'text',
                content: '',
                position: ''
                // loop over .tooltip element attributes and set up options
            };
            for (var ai = 0; ai < tooltip.attributes.length; ai++) {
                var attr = tooltip.attributes[ai];
                if (/^tooltip-/.test(attr.name)) {
                    options[attr.name.split('-').pop()] = attr.value;
                }
            }
            // create tooltip from options
            this.createTooltip(tooltip, options);
        }
    }

    _buttons_init() {
        var $buttons = [].concat(_toConsumableArray(document.querySelectorAll('.button.button--loading')));
        if ($buttons) {
            var $loading = document.querySelector('.loading');
            $buttons.forEach(function ($button) {
                $button.addEventListener('click', function (e) {
                    var $errors = [].concat(_toConsumableArray(document.querySelectorAll('.error ul li')));
                    if (!$errors || $errors.length === 0) {
                        $button.style.display = 'none';
                        $loading.style.display = 'block';
                    } else {
                        e.preventDefault();
                    }
                });
            });
        }
    }

    _timeout_init() {
        setTimeout(function () {
            var error = document.querySelector('.error ul li');
            if (error) {
                error.scrollIntoView();
            }
        }, 1000);
    }
}